export default __webpack_public_path__ + "static/media/default-card-image-COMMON.6c3a3565.jpg";